import React, { useState } from 'react';
import './App.css';

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="app-container">
      {/* --- NAVIGATION --- */}
      <nav className="navbar">
        <div className="logo">
          <span className="logo-text">FLEX <span className="logo-accent">FITNESS</span></span>
        </div>
        <div className="menu-icon" onClick={() => setIsMenuOpen(!isMenuOpen)}>
          ☰
        </div>
        <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
          <li><a href="#home">Home</a></li>
          {/* <li><a href="#programs">Programs</a></li> */}
          <li><a href="#coaching">Coaching</a></li>
          <li><a href="#membership">Membership</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
        {/* <button className="join-btn">Join Now</button> */}
        <a href="https://m.me/100069922874208" target="_blank" rel="noopener noreferrer" className="join-btn">
          Join Now
        </a>
      </nav>

      {/* --- HERO SECTION --- */}
      <header id="home" className="hero">
        <div className="hero-content">
          <h1>YOUR ONLY LIMIT IS<br /> <span>YOU</span></h1>
          <p>Train with the best equipment and trainers in town.</p>
          {/* <button className="cta-button">Start Free Trial</button> */}
        </div>
      </header>

      {/* --- COACHING SECTION --- */}
      <section id="coaching" className="coaching">
        <h2>Coaching & Training</h2>
        <p className="section-subtitle">Expert trainers certified by <span className="gold-text">Gold's Gym</span></p>

        <div className="coaching-grid">
          <div className="coach-card">
            {/* <div className="coach-badge">Gold's Gym Certified</div> */}
            <div className="coach-image">
              <img src="https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Weight Loss" />
            </div>
            <div className="coach-info">
              <h3>Weight Loss & Training</h3>
              {/* <p className="price">$45<span>/session</span></p> */}
              <ul>
                <li>Fat burning workouts</li>
                <li>Calorie deficit planning</li>
                <li>Cardio & HIIT sessions</li>
              </ul>
              {/* <button>Book Now</button> */}
            </div>
          </div>

          <div className="coach-card">
            {/* <div className="coach-badge">Gold's Gym Certified</div> */}
            <div className="coach-image">
              <img src="https://images.unsplash.com/photo-1490645935967-10de6ba17061?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Nutrition Plan" />
            </div>
            <div className="coach-info">
              <h3>Nutrition Plan</h3>
              {/* <p className="price">$80<span>/month</span></p> */}
              <ul>
                <li>Custom meal plans</li>
                <li>Macronutrient tracking</li>
                <li>Supplement guidance</li>
              </ul>
              {/* <a href="https://m.me/100069922874208" target="_blank" rel="noopener noreferrer" className="select-btn">
                Book Now
              </a> */}
            </div>
          </div>

          <div className="coach-card">
            {/* <div className="coach-badge">Gold's Gym Certified</div> */}
            <div className="coach-image">
              <img src="https://images.unsplash.com/photo-1517836357463-d25dfeac3438?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Sport Conditioning" />
            </div>
            <div className="coach-info">
              <h3>Sport Conditioning</h3>
              {/* <p className="price">$55<span>/session</span></p> */}
              <ul>
                <li>Athletic performance</li>
                <li>Agility & speed training</li>
                <li>Sport-specific drills</li>
              </ul>
              {/* <a href="https://m.me/100069922874208" target="_blank" rel="noopener noreferrer" className="select-btn">
                Book Now
              </a>             */}
              </div>
          </div>

          <div className="coach-card">
            {/* <div className="coach-badge">Gold's Gym Certified</div> */}
            <div className="coach-image">
              <img src="https://images.unsplash.com/photo-1534438327276-14e5300c3a48?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80" alt="Personalized Training" />
            </div>
            <div className="coach-info">
              <h3>Personalized Training</h3>
              {/* <p className="price">$60<span>/session</span></p> */}
              <ul>
                <li>Custom workout plans</li>
                <li>One-on-one coaching</li>
                <li>Goal tracking & support</li>
              </ul>
              {/* <a href="https://m.me/100069922874208" target="_blank" rel="noopener noreferrer" className="select-btn">
                Book Now
              </a> */}
            </div>
          </div>
        </div>
      </section>

      {/* --- MEMBERSHIP SECTION --- */}
      <section id="membership" className="membership">
        <h2>Membership Plans</h2>

        <div className="membership-container">
          {/* Student Plan */}
          <div className="membership-card student">
            <div className="card-header">
              <h3>👨‍🎓 Student Plan</h3>
              <p>Special rates for students with valid ID</p>
            </div>
            <div className="card-body">
              <div className="price-option">
                <span className="option-name">Daily</span>
                <span className="option-price">₱80<span>/day</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">Weekly</span>
                <span className="option-price">₱300<span>/week</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">Half Month</span>
                <span className="option-price">₱500<span>/2 weeks</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">Monthly</span>
                <span className="option-price">₱800<span>/mo</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">2 - Months</span>
                <span className="option-price">₱1,700<span>/2 mo</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">3 - Months</span>
                <span className="option-price">₱2,400<span>/3 mo</span></span>
              </div>
            </div>
            <a href="https://m.me/100069922874208" target="_blank" rel="noopener noreferrer" className="select-btn">
              Get Started
            </a>
          </div>

          {/* Regular Plan */}
          <div className="membership-card regular featured">
            <div className="popular-badge">Most Popular</div>
            <div className="card-header">
              <h3>💪 Regular Plan</h3>
              <p>Flexible options for everyone</p>
            </div>
            <div className="card-body">
              <div className="price-option">
                <span className="option-name">Daily</span>
                <span className="option-price">₱90<span>/day</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">Weekly</span>
                <span className="option-price">₱300<span>/week</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">Half Month</span>
                <span className="option-price">₱500<span>/2 weeks</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">Monthly</span>
                <span className="option-price">₱900<span>/mo</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">2 - Months</span>
                <span className="option-price">₱1,700<span>/2 mo</span></span>
              </div>
              <div className="price-option">
                <span className="option-name">3 - Months</span>
                <span className="option-price">₱2,400<span>/3 mo</span></span>
              </div>
            </div>
            <a href="https://m.me/100069922874208" target="_blank" rel="noopener noreferrer" className="select-btn">
              Get Started
            </a>
          </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer id="contact" className="footer">
        <div className="footer-container">
          <div className="footer-col">
            <div className="logo">
              <span className="logo-text">FLEX <span className="logo-accent">FITNESS</span></span>
            </div>
            <p>Start your fitness journey with us. At Flex Fitness, you’ll find top-quality equipment, knowledgeable trainers, and a welcoming community that supports you every step of the way.</p>

          </div>

          <div className="footer-col">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              {/* <li><a href="#programs">Programs</a></li> */}
              <li><a href="#coaching">Coaching</a></li>
              <li><a href="#membership">Membership</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact Us</h4>
            <ul className="contact-info">
              <li>
                <a
                  href="https://www.google.com/maps/dir//Flex+Fitness,+Buli,+Taal,+4208+Batangas/"
                  target="_blank"
                  rel="noopener noreferrer"
                // className="directions-btn"
                >
                  <span>📍</span> Buli, Taal, 4208 Batangas
                </a>
              </li>
              {/* <li>
                <span>📧</span> hello@flexfitness.com
              </li> */}
              <li>
                <span>📞</span> 09055767466 / 09273674840
              </li>
            </ul>
            <div className="social-links">
              <a href="https://www.facebook.com/profile.php?id=100069922874208" target="_blank" rel="noopener noreferrer" className="social-icon facebook">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
              </a>
              <a href="https://www.instagram.com/flex_fitness_24/" target="_blank" rel="noopener noreferrer" className="social-icon instagram">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4>Opening Hours</h4>
            <ul className="hours">
              <li>Monday - Saturday</li>
              <li>6:00 AM - 9:00 PM</li>
              <li>Sunday</li>
              <li>CLOSED</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2024 <strong>Flex Fitness</strong>. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default App;